// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/patient-payment/patient-payment-report.less
// module id = 3999
// module chunks = 0